import FixtureLatestVideo from "./FixtureLatestVideo";
export default FixtureLatestVideo;
